import React from 'react';
import { Button, Form, FormGroup, Input, Label, FormFeedback, Card, CardBody } from 'reactstrap';
import { SendNotificationsFormValidator } from 'form-validations';
import {connect} from 'react-redux';
import {NotificationAction} from 'redux/actions';

const Notifications = (props) => {

    let [values, setValues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isSubmitted, setIsSubmitted] = React.useState(false);
    let [isValid, setIsValid] = React.useState(true);
    React.useEffect(() => {
        validate(values)
    }, [values]);


    React.useEffect(() => {
        setValues({});
        setIsSubmitted(false);
    }, [props.notificationsSent]);

    const validate = (values) => {
        const validationErrors = SendNotificationsFormValidator(values);
        setIsValid((Object.keys(validationErrors).length === 0));
        setErrors(validationErrors);
    }
    const usersTypes = [
        {
            label: 'All Users',
            value: 'ALL'
        },
        {
            label: 'Android Users Only',
            value: 'android'
        },
        {
            label: 'IOS Users Only',
            value: 'ios'
        }
    ]
    const handleChange = (event) => {
        setValues({
            ...values, [event.target.name]: event.target.value
        })
    };
    const handleSubmit = () => {
        console.log('Values:', values)
        validate(values);
        setIsSubmitted(true);
        setIsSubmitted(true);
        if (isValid) {
            props.sendNotification(values);
        }
    }
    return (
        <div>
            <Card body className="login-card">
                <CardBody>
                    <Form>

                        <FormGroup>
                            <Label for={'occupants'}>{'Select Users'}</Label>
                            <Input className="mb-2" type="select" name="occupants" id="occupants" onChange={handleChange}>
                                <option value={0}>Select Users</option>
                                {usersTypes.map((item) => (<option selected={(values.occupants===item.value)?true:false} key={item.value} value={item.value} >{item.label}</option>))}
                            </Input>
                            {(isSubmitted && errors.occupants && !values.occupants) && <FormFeedback >{errors.occupants} </FormFeedback>}
                        </FormGroup>


                        <FormGroup>
                            <Label for={'message'}>{'Message'}</Label>
                            <Input
                                type="textarea"
                                name="message"
                                id="message"
                                onChange={handleChange}
                                autoComplete={'off'}
                                value={(values && values.message) ? values.message : ''}
                            />
                            {(isSubmitted && errors.message && !values.message) && <FormFeedback >{errors.message} </FormFeedback>}
                        </FormGroup>
                        <FormGroup>
                            <Button
                                color="primary"
                                className="border-0"
                                block
                                style={{ width: 200 }}
                                onClick={handleSubmit}
                            >
                                Send Notifications
                            </Button>
                        </FormGroup>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}



export default connect((state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    notificationsSent: (state.notifications && state.notifications.notificationsSent) ? state.notifications.notificationsSent : null,
}), (dispatch) => ({
    sendNotification: (payload)=>dispatch(NotificationAction.sendNotification(payload))
}))(Notifications);

